if (!customElements.get('tru-store-stock')) {
  customElements.define('tru-store-stock', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.tru-store-stock__open');
      opener.addEventListener('click', () => dialog.showModal());
      this.querySelector('.tru-store-stock__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => opener.focus());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    }
  });
}
